const { merge, pickBy } = require('lodash');

const VALID_EMPTY_VALUES = [0, false];

/**
 * Merge multiple source into one object with undefined values omitted.
 *
 * @param {Object} sources - source objects to merge
 * @returns {Object} merged sources without undefined values
 */
const mergeObjects = (...sources) => {
    const mergedObject = merge({}, ...sources);

    return omitEmptyValues(mergedObject);
};

/**
 * Returns a new object will all keys omitted which have an empty value.
 *
 * @param {Object} source - source object to omit empty values from.
 * @returns {Object}
 */
const omitEmptyValues = (source) => pickBy(source, (value) => VALID_EMPTY_VALUES.includes(value) || !!value);

module.exports = {
    mergeObjects,
    omitEmptyValues,
};
